<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <!-- <div class="d-flex flex-column flex-md-row">
            <div class="col-12 col-md-2 p-0 m-0 mx-0 mx-md-2 my-2 my-md-0">
              <bita-bootbutton
                icon="fas fa-filter"
                type="success"
                class="w-100"
                title="فیلتر بیشتر"
                @click.native="toggleFilters"
              />
            </div>
          </div> -->
         <div class="d-flex align-items-center flex-column flex-md-row">

            <bita-bootbutton
              type="danger"
              title="حذف فیلتر"
              class="col-lg-1 mt-3 ml-3"
              style="height: 35px"
              @click.native="reset"
            />
          </div>
          <div style="text-align: center; margin-bottom: 20px;">
            <transition name="fade">
              <div>
                <hr />
                <bita-form ref="form">
                  <div slot="body">
                    <div class="row">
                      <bita-datepicker
                        ref="fromdate"
                        type="date"
                        id="fromDate"
                        validation-container-class="col-lg-2"
                        name="from-date"
                        label="از تاریخ"
                        inputClass="form-control"
                        v-model="filters.fromDate"
                        @change="(e) => search(e)"
                      />

                      <bita-datepicker
                        ref="todate"
                        type="date"
                        id="toDate"
                        validation-container-class="col-lg-2"
                        name="to-date"
                        label="تا تاریخ"
                        inputClass="form-control"
                        v-model="filters.toDate"
                        @change="(e) => search(e)"
                      />
                  <bita-select
                        type="created_by"
                        name="created_by"
                        label="ایجاد کننده"
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        :data-source="users"
                        data-text-field="full_name"
                        data-value-field="id"
                        v-model="filters.created_by"
                        @change="(e) => search(e)"

                     
                      />
                      <bita-select
                      ref="statesDropDown"
                      name="states"
                      label="وضعیت"
                      rules
                      validation-container-class="col-lg-2"
                      input-class="form-control"
                      :data-source="states"
                      data-text-field="name"
                      data-value-field="status_id"
                      v-model="filters.state_id"
                      @change="(e) => search(e)"
                    />
                    <bita-select
                      name="state"
                      label="استان مبدا"
                      ref="originStateDropDown"
                      rules
                      validation-container-class="col-lg-2"
                      input-class="form-control"
                      :data-source="state"
                      data-text-field="name"
                      data-value-field="id"
                      v-model="filters.origin_province_id"
                      @change="(e) => this.getCityOrgin(e)"
                    />

                    <bita-spinner
                      :is-loading="isLoadingCitiesOrgin"
                      class-name="col-lg-2"
                      styleName="align-self: center;"
                    />

                    <bita-select
                      v-if="this.isLoadingCitiesOrgin === false"
                      name="citiesOrgin"
                      label="شهر مبدا"
                      ref="citiesOrginDropDown"
                      rules
                      validation-container-class="col-lg-2"
                      input-class="form-control"
                      :data-source="citiesOrgin"
                      data-text-field="name"
                      data-value-field="id"
                      v-model="filters.origin_city_id"
                      @change="(e) => search(e)"
                    />
                    <bita-select
                      name="state"
                      label="استان مقصد"
                      ref="destinationstateDropDown"
                      rules
                      validation-container-class="col-lg-2"
                      input-class="form-control"
                      :data-source="state"
                      data-text-field="name"
                      data-value-field="id"
                      v-model="filters.destination_province_id"
                      @change="(e) => this.getCityDestination(e)"
                    />

                    <bita-spinner
                      :is-loading="isLoadingCitiesDestination"
                      class-name="col-lg-2"
                      styleName="align-self: center;"
                    />

                    <bita-select
                      v-if="this.isLoadingCitiesDestination === false"
                      name="citiesDestination"
                      label="شهر مقصد"
                      ref="citiesDestinationDropDown"
                      rules
                      validation-container-class="col-lg-2"
                      input-class="form-control"
                      :data-source="citiesDestination"
                      data-text-field="name"
                      data-value-field="id"
                      v-model="filters.destination_city_id"
                      @change="(e) => search(e)"
                    />
                    </div>
                  </div>
                </bita-form>
              </div>
            </transition>
          </div>
          <hr />
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :grid-server-side="true"
            :schema-total="'total'"
            :schema-data="'data'"

            :batch="true"
            :resizable="true"

          />
        </div>
      </bita-ibox>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        {
          title: "گزارش ها",
          link: "report/general",
          active: true,
        },
      ],
      isLoadingGrid: false,
      filters: {},
      pageSize: 0,
      currentPage: 0,
       states: [],
       users:[],
      state: [],
      isLoadingCitiesOrgin: false,
      isLoadingCitiesDestination: false,
      citiesOrgin: [],
      citiesDestination : [],
      totalSum:{}

    };
  },
  mounted() {
this.isLoadingGrid = true;
    Promise.all([
      this.getStates(),
      this.getUsers(),
      this.getState(),
    ]).then((res) => {
      this.states = res[0].data;
      this.users = res[1].data;
      this.state = res[2].data;


    });

  },
  computed: {
    gridColumns() {
      return [
        { title: "#", template: this.getTemplateID, width: "20px" },

        {
          field: "origin",
          title: "مبدا",
          template: (e) => (e ? `${e.origin}` : "-"),
          width: "60px", 
        },

        {
          field: "destination",
          title: "مقصد",
          template: (e) => (e ? `${e.destination}` : "-"),
          width: "60px",
        },

        {
          field: "total",
          title: "تعداد",
          template: (e) => (e ? `${e.total}` : "-"),
          width: "60px",

          footerTemplate: () => this.totalSum
        },

        {
          field: "name",
          title: "وضعیت",
          template: (e) => (e ? `${e.name}` : "-"),
          width: "60px",
        },


      ];
    },
  },
  methods: {

    getTemplateID() {
      return this.$refs.grid.getTemplateLocal();
    },
    readData(e) {
      this.pageSize = e.data.pageSize;
      this.currentPage = e.data.page;
      this.$resetGrid();
      this.isLoadingGrid = true;
      let baseUrl = `reports/ggr?page=${this.currentPage}&page_size=${
        this.pageSize
      }&state_id=${this.filters.state_id || ""}&from=${this.filters.fromDate ||
        ""}&to=${this.filters.toDate || ""}&created_by=${this.filters.created_by ||
        ""}&originCity=${this.filters.origin_city_id || ""}&destinationCity=${this.filters.destination_city_id || ""}`;
      let url = this.$makeQueryStringForSpatie(baseUrl);
      this.$persistClient("get", url)
        .then((res) => {
          this.totalSum = res.data.data.total_sum
          e.success(res.data.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },



    loadData() {
      this.$refs.grid.loadDataSource();
    },
      getStates() {
      return this.$persistClient("get", "states?type=request-ticket");
    },
        getUsers() {
      return this.$persistClient("get", `requests/users`);
    },

    search: _.debounce(function() {
      this.loadData();
    }, 1000),
    getState() {
      return this.$persistClient("get", "cities?filter[province]=0");
    },

        getCityOrgin(stateId) {
      this.isLoadingCitiesOrgin = true;
      this.$persistClient("get", `cities?filter[province]=${stateId}`)
        .then((res) => {
          this.citiesOrgin = res.data;
        })
        .finally(() => {
          this.isLoadingCitiesOrgin = false;
        });
    },
    getCityDestination(stateId) {
      this.isLoadingCitiesDestination = true;
      this.$persistClient("get", `cities?filter[province]=${stateId}`)
        .then((res) => {
          this.citiesDestination = res.data;
        })
        .finally(() => {
          this.isLoadingCitiesDestination = false;
        });
    },
reset() {
  Object.keys(this.filters).forEach(key => this.filters[key] = "");
  this.loadData();
}
  },
};
</script>
<style scoped>
.label {
  font-family: "iranyekan";
}
.fade-enter {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 1s ease-in;
}
.fade-leave {
  opacity: 0.2;
}
</style>
